import * as z from 'zod';

export type UserTaskStatus = 'open' | 'closed_success' | 'closed_fail';

export const UserTask = z.object({
  id: z.number(),
  status: z.string(),
  title: z.string(),
  description: z.string().optional(),
  owner: z.string(),
  owner_id: z.number(),
  creator: z.string(),
  creator_id: z.number(),
  created_at: z.number(),
  updated_at: z.number(),
  closed_at: z.number().nullable(),
  time_limit: z.preprocess((val) => Number(val), z.number()),
  due_date: z.string().optional().nullable(),
  type: z.string(),
  related_to_id: z.number(),
  related_to_url: z.string(),
});

export const UserTasksListResponse = z.object({
  items: z.array(UserTask),
  total: z.number(),
});

export const UserTaskDetails = UserTask.extend({
  related_issue_id: z.number(),
  related_issue_code: z.string(),
});

export type UserTask = z.infer<typeof UserTask>;
export type UserTaskDetails = z.infer<typeof UserTaskDetails>;
export type UserTasksListResponse = z.infer<typeof UserTasksListResponse>;
